import { CoachingSessionDto } from '../../coach/dto/coaching-session.dto';
import { EventDto } from '../../event/dto/event.dto';
import { PaymentIntentDto } from '../../payment/dto/payment-intent.dto';
import { UserDto } from '../../user/dto/user.dto';
import { GameDto } from './game.dto';

export class RefundDto {
  id: string;
  paymentIntent: PaymentIntentDto;
  game?: GameDto;
  coachingSession?: CoachingSessionDto;
  event?: EventDto;
  user: UserDto;
  // The covered player whose share was refunded, for partial pay-for-others
  // refunds. Undefined for full-PI refunds (the typical/legacy case) and for
  // queries that did not populate the relation.
  coveredUser?: UserDto;
  // Refund amount in cents. null means "refund the full PI amount" (legacy
  // semantics for rows created before pay-for-others). Partial refunds always
  // populate this so the "My Cancellations" feed shows the actual refund.
  amountCents?: number | null;
  status: RefundStatus;
  reason: string;
  createdAt: Date;
  processedAt?: Date;
  errorMessage?: string;
}

export enum RefundStatus {
  SUCCESSFUL = 'SUCCESSFUL',
  RETRY = 'RETRY',
  // Terminal failure — the retry cron gave up after a permanent (non-retryable)
  // error. `errorMessage` carries the reason. Render distinctly from RETRY.
  FAILED = 'FAILED',
}
